// Maps a stored campaign paused_reason to a short customer-facing badge.
export type PauseBadge = { label: string; tone: "danger" | "warning" | "muted"; full: string };

export function pauseBadgeOf(reason: string | null | undefined): PauseBadge {
  const r = (reason || "").trim();
  const low = r.toLowerCase();
  const full = r || "Paused manually";
  if (low === "seat_expired" || low === "subscription_expired")
    return { label: "Account needs renewing", tone: "danger", full: "The account's seat has expired. Renew it to resume." };
  if (low.includes("session expired") || low.includes("credentials"))
    return { label: "LinkedIn reconnect needed", tone: "warning", full };
  if (low.includes("moved to another workspace") || low.includes("re-added"))
    return { label: "Account changed — reconnect", tone: "warning", full };
  if (low.includes("resume failed")) return { label: "Resume failed — try again", tone: "warning", full };
  if (low === "workspace_churned") return { label: "Inactive workspace", tone: "muted", full: "Workspace was inactive." };
  return { label: "Paused", tone: "muted", full };
}

export const pauseBadgeClass: Record<PauseBadge["tone"], string> = {
  danger: "border-destructive/30 bg-destructive/10 text-destructive",
  warning: "border-warning/30 bg-warning/10 text-warning",
  muted: "border-border bg-muted text-muted-foreground",
};
